import { StrengthMeterSquares } from '@/components/strength-meter/StrengthMeterSquares';
import { StrengthCalculator } from '@/components/strength-meter/StrengthCalculator';
import { StrengthMeterHoverController } from '@/components/strength-meter/StrengthMeterHoverController';

export class StrengthMeter {
  constructor(
    holderDiv,
    currencies,
    timeframes,
    instrumentData,
    listBlocksFunction,
    typeCalculator,
    listGroups
  ) {
    this.uiDiv = holderDiv;
    this.parentDiv = holderDiv.querySelector('.js-heatmap-canvas');
    this.strengthCalculator = new StrengthCalculator(typeCalculator);
    this.strengthCalculator.initializeStrCalculator(
      instrumentData,
      currencies,
      timeframes
    );
    this.listCurrencies = currencies; //listCurrencies;
    this.timeFrames = timeframes; //timeFrames;
    this.listGroups = listGroups;
    this.parentDiv.style.height = this.getHeatmapHeight();
    this.strengthMeterHoverController = new StrengthMeterHoverController(this);

    const listBlocks = listBlocksFunction(this);
    this.heatmap = new StrengthMeterSquares(
      {
        name: listBlocks.name,
        cssClass: listBlocks.cssClass,
        children: listBlocks.children,
        margin: listBlocks.margin,
      },
      this.strengthMeterHoverController
    );

    // Class method binding
    this.drawStrengthMeter = this.drawStrengthMeter.bind(this);
    this.addListeners = this.addListeners.bind(this);
    this.getHeatmapHeight = this.getHeatmapHeight.bind(this);
  }

  drawStrengthMeter() {
    this.parentDiv.innerHTML = '';
    this.strengthMeterHoverController.popup.innerHTML = '';
    this.heatmap.drawElements(this.parentDiv);
    this.addListeners();
  }

  addListeners() {
    //moving popup over heatmap
    const leftBorder = this.parentDiv.getBoundingClientRect().left;
    const rightBorder = this.parentDiv.getBoundingClientRect().right;
    const headerHeight = document.querySelector('header').offsetHeight;
    let listCurrencyBlocks = this.parentDiv.querySelectorAll('.currency-block');
    if (listCurrencyBlocks.length == 0) {
      listCurrencyBlocks = this.parentDiv.querySelectorAll('.pair-block');
    }
    listCurrencyBlocks.forEach((currencyBlock) => {
      currencyBlock.addEventListener('click', () => {
        if (screen.width < 768) {
          return;
        }
        this.strengthMeterHoverController.popup.classList.toggle('d-none');
      });
      currencyBlock.addEventListener('mouseenter', () => {
        const rect = currencyBlock.getBoundingClientRect();
        const windowWidth = document.documentElement.clientWidth;
        const leftCoord = rect.right + 15;
        const rightCoord =
          rect.left - 15 - this.strengthMeterHoverController.popup.offsetWidth;
        if (windowWidth < 768) {
          this.strengthMeterHoverController.popup.style.left = `${leftBorder}px`;
          this.strengthMeterHoverController.popup.style.top = `${
            rect.top + window.scrollY + rect.height
          }px`;
          return;
        }

        if (rect.right - rect.width === 70) {
          this.strengthMeterHoverController.popup.style.left = `${
            leftCoord - rect.width
          }px`;
        } else if (
          Math.abs(rightCoord - leftBorder) > Math.abs(rightBorder - leftCoord)
        ) {
          this.strengthMeterHoverController.popup.style.left = `${rightCoord}px`;
        } else {
          this.strengthMeterHoverController.popup.style.left = `${leftCoord}px`;
        }
        this.strengthMeterHoverController.popup.style.top = `${
          rect.top + 6 + window.scrollY
        }px`;
        if (rect.right - rect.width === 70) {
          this.strengthMeterHoverController.popup.style.top = `${
            rect.bottom + headerHeight + window.scrollY
          }px`;
        } else if (rect.top < headerHeight + 10) {
          this.strengthMeterHoverController.popup.style.top = `${
            window.scrollY + headerHeight + 10
          }px`;
        } else {
          this.strengthMeterHoverController.popup.style.top = `${
            rect.top + 6 + window.scrollY
          }px`;
        }
      });
      currencyBlock.addEventListener('mouseover', () => {
        const windowWidth = document.documentElement.clientWidth;
        if (windowWidth < 768) {
          return;
        }
        if (
          !this.strengthMeterHoverController.popup.classList.contains('d-none')
        ) {
          const rect = currencyBlock.getBoundingClientRect();
          if (rect.right - rect.width === 70) {
            this.strengthMeterHoverController.popup.style.top = `${
              rect.bottom + headerHeight + window.scrollY
            }px`;
          } else if (rect.top < headerHeight + 10) {
            this.strengthMeterHoverController.popup.style.top = `${
              window.scrollY + headerHeight + 10
            }px`;
          } else {
            this.strengthMeterHoverController.popup.style.top = `${
              rect.top + 6 + window.scrollY
            }px`;
          }
        }
      });
    });
    //    hiding popup
    this.parentDiv.addEventListener('mouseleave', () => {
      this.strengthMeterHoverController.popup.classList.add('d-none');
    });
    this.parentDiv.addEventListener('mouseenter', () => {
      this.strengthMeterHoverController.popup.classList.remove('d-none');
    });
  }

  getHeatmapHeight() {
    const headerHeight = document
      .querySelector('header')
      .getBoundingClientRect().height;
    const pairsNum =
      this.strengthCalculator.listIndex[0].listPairs.length *
      this.strengthCalculator.listIndex.length;
    const numberOfCells = pairsNum * this.timeFrames.length;
    const heatmapWidth = this.parentDiv.getBoundingClientRect().width;
    const freeHeight = window.innerHeight * 0.98 - headerHeight;
    const heatmapSquare = numberOfCells * 3000;
    let heatmapHeight = heatmapSquare / heatmapWidth;
    if (heatmapHeight < freeHeight) {
      heatmapHeight = freeHeight;
    }
    return `${heatmapHeight}px`;
  }
}
